import { setContext, getContext } from 'svelte';
import type { TabId } from './sidepanel-types';

export interface SidepanelTabNavigationContext {
	navigateToTab: (
		tabId: TabId,
		options?: { openedEventTimestamp?: number; activeHistoryButton?: number },
	) => void;
	getTabIndex: (tabId: TabId) => number;
	openedEventTimestamp?: number | null;
	activeHistoryButton: number | null;
}

const CONTEXT_KEY = Symbol('sidepanel-tab-navigation');

export const setSidepanelTabNavigationContext = (context: SidepanelTabNavigationContext) => {
	setContext(CONTEXT_KEY, context);
};

export const getSidepanelTabNavigationContext = (): SidepanelTabNavigationContext | undefined => {
	return getContext<SidepanelTabNavigationContext>(CONTEXT_KEY);
};
